import { createContext, ReactNode, useContext, useMemo } from 'react';
import { VariableOpportunityContext } from '../model/variable-suggestions';

const Ctx = createContext<VariableOpportunityContext | undefined>(undefined);

export interface VariableOpportunitiesProviderProps extends VariableOpportunityContext {
  children: ReactNode;
  enabled?: boolean;
}

export function VariableOpportunitiesProvider({
  children,
  enabled = true,
  otherQueries,
  variableDefinitions,
}: VariableOpportunitiesProviderProps) {
  const value = useMemo(
    (): VariableOpportunityContext | undefined => (enabled ? { otherQueries, variableDefinitions } : undefined),
    [enabled, otherQueries, variableDefinitions]
  );
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useVariableOpportunityContext(): VariableOpportunityContext | undefined {
  return useContext(Ctx);
}
